// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Product } from './product';
import { ProductUnitOfMeasure } from './product-unit-of-measure';
import { Quote } from './quote';

/// <code-import> Place custom imports between <code-import> tags
import { Utility } from '../utility';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class QuoteLine extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get lineTotal() {
        return this.quantity * this.price;
    }

    get tax() {
        if (this.isTaxable) return Utility.SalesTaxRate * this.quantity * this.price;
        else return 0;
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  description?: string;
  isMisc!: boolean;
  isTaxable!: boolean;
  lineNumber!: number;
  notes?: string;
  partNumber?: string;
  price!: number;
  productId?: number;
  quantity!: number;
  quoteId!: number;
  unit?: string;
  unitOfMeasureId?: number;
  product!: Product;
  quote!: Quote;
  unitOfMeasure!: ProductUnitOfMeasure;
}

